module.exports = __webpack_public_path__ + "style/img/BossDI.f33b4875.png";